import React from 'react'

import styled, { css } from 'styled-components'

import { variables } from 'src/Styled/variables'
import { secondaryButtonStyles } from 'src/Components/Buttons/PrimaryButton'
import TranslationIcon from 'src/Assets/Svg/common/translation.svg?react'

export interface TranslateButtonProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'type'
> {
  translated?: boolean
  loading?: boolean
  label?: string
}

const StyledButton = styled.button<{ $loading?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 32px;
  padding: 0 24px;
  border-radius: 8px;
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  white-space: nowrap;

  ${secondaryButtonStyles}

  ${({ $loading }) =>
    $loading &&
    css`
      &:disabled {
        cursor: default;
      }

      svg {
        path {
          fill: currentColor;
        }
      }
    `}
`

const IconWrapper = styled.span`
  display: inline-flex;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`

export const TranslateButton: React.FC<TranslateButtonProps> = ({
  translated = false,
  loading = false,
  label = 'Translate',
  disabled,
  ...rest
}) => {
  const getText = (): string => {
    if (loading) {
      return 'Translating…'
    }
    if (translated) {
      return 'Show original'
    }
    return label
  }

  return (
    <StyledButton
      type='button'
      disabled={disabled || loading}
      $loading={loading}
      {...rest}
    >
      <IconWrapper>
        <TranslationIcon />
      </IconWrapper>
      <span>{getText()}</span>
    </StyledButton>
  )
}
